import React from 'react';

const airlineCode = (props) => {
    const FS = props.FS;
    let flightNumber = FS[0].fl;
    let flightCode = FS[0].oac || FS[0].ac;
    let travelClass = FS[0].travelclass;
    for(let i = 1; i < FS.length; i++) {
        flightNumber += `/ ${FS[i].fl}`;
    }
    return <span className="u-fontSize11 u-lineHeight15 u-textColorMedium u-block u-phone-fontSize11">{flightCode} {flightNumber}{`(${travelClass})`}</span>;
}

export default airlineCode;


// WEBPACK FOOTER //
// ./src/components/Flight/Airline/AirlineCode/AirlineCode.js